import React, {useState, useEffect, useRef} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const PayrollitemListComponent = (props) => {

  const {t} = props;
  const {id} = useParams();
  const [payrollitems, setPayrollitems] = useState([]);
  const [payrollItemTypes, setPayrollItemTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {

      Promise.all([
        apiCall('get', '/api/v2/payroll-item-type?search[active][operator]==&search[active][value]=true'),
        apiCall('get', '/api/v2/payroll-entry?search[payroll][operator]==&search[payroll][value]=' + id)
      ])
        .then(([typesResponse, itemsResponse]) => {
          const itemTypes = typesResponse?.data?.data?.items || [];
          const items = itemsResponse?.data?.data?.items || [];
          setPayrollItemTypes(itemTypes);
          const groupedItems = {};
          items.forEach((entry) => {
            const employeeId = entry?.employee?.id;
            if (!employeeId) return;

            if (!groupedItems[employeeId]) {
              groupedItems[employeeId] = {
                id: employeeId,
                employee_name: entry?.employee?.name || '',
                payroll_currency: entry?.payroll?.currency || '',
                created_at: entry?.created_at || null,
                updated_at: entry?.updated_at || null,
              };
            }
            if (entry.payroll_items && Array.isArray(entry.payroll_items)) {
              entry.payroll_items.forEach((pItem) => {
                const payrollItemTypeId = pItem?.payroll_item_type?.id;
                if (payrollItemTypeId) {
                  groupedItems[employeeId]['type_' + payrollItemTypeId] = pItem?.amount;
                }
              });
            }
          });
          const transformedItems = Object.values(groupedItems);
          setTotalRecords(transformedItems.length);
          setPayrollitems(transformedItems);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  // const actionBodyTemplate = (rowData) => {
  //   return (
  //     <React.Fragment>
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
  //                 tooltip={t('edit')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if(entity === 'tmp') {
  //                     history.push('/inventory/tmp/update/' + rowData.id)
  //                   }
  //                 }}/>
  //       }
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-trash" className="p-button-danger"
  //                 tooltip={t('delete')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if (window.confirm('A törlés megerősítésére van szükség!')) {
  //                     setLoading(true);
  //                     apiCall('delete', '/api/v2/tmp/' + rowData.id)
  //                       .then(response => {
  //                         window.App.toastShow('success', 'Sikeres törlés!');
  //                         window.App.setState({rerenderTmpList: Math.random()})
  //                       })
  //                       .catch(error => {
  //                         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //                       })
  //                       .finally(() => {
  //                         setLoading(false);
  //                       })
  //                   }
  //                 }}
  //         />
  //       }
  //     </React.Fragment>
  //   );
  // }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderPayrollItemList, id])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={payrollitems} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="employee_name" header={t('columnEmployee')} sortable filter></Column>

        {payrollItemTypes.map((type) => (
          <Column key={type.id} field={'type_' + type.id} header={type.name} headerStyle={{whiteSpace: 'nowrap'}} bodyStyle={{whiteSpace: 'nowrap'}}
            body={(rowData) => {
              const value = rowData['type_' + type.id];
              if (value === null || value === undefined || value === '') {
                return '';
              }
              return (
                <span style={{ whiteSpace: 'nowrap' }}>
                  {window.App.currencyFormatter(rowData.payroll_currency, value)}
                </span>
              );
            }}
          />
        ))}

        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return rowData.created_at ? (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          ) : <></>
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return rowData.updated_at ? (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          ) : <></>
        }}></Column>
        {/* <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column> */}
      </DataTable>
    </>
  )
}
export default withTranslation('common')(PayrollitemListComponent);